import { switchMap, withLatestFrom } from 'rxjs';
import { EMPTY, Observable, of } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { cartVariantAndId } from 'src/core/state/cart';
import { CartVariant } from 'src/core/state/cart';
import { execute as fetchMine } from 'swagger/ts/WorkwearExpressCustomisationPlatformFrontendExistingCustomisationsRepositoryV1GetExistingCustomisationsWithCartGet';
import { execute as fetchGuest } from 'swagger/ts/WorkwearExpressCustomisationPlatformFrontendExistingCustomisationsRepositoryV1GetExistingCustomisationsWithCartForGuestGet';
import { Deps } from 'src/types/global-types';
import { catchableUnauthenticated } from 'src/core/state/user';
import Bugsnag from '@bugsnag/js';

import { ArtworkActions, ArtworkMsg, TypeMap } from '../artwork.register';

export function artworkFetch(action$: Observable<any>, state$: Observable<any>, deps: Deps) {
    return action$.pipe(
        ofType<ArtworkActions, TypeMap['ArtworkGrid.Fetch']>('ArtworkGrid.Fetch'),
        withLatestFrom(cartVariantAndId(state$), (_action, variantAndId) => variantAndId),
        switchMap(([variant, cartId]) => {
            if (!cartId) {
                Bugsnag.notify('cartId was missing');
                return EMPTY;
            }

            const ajax =
                variant === CartVariant.Account ? fetchMine(deps) : fetchGuest({ cartId: String(cartId) }, deps);

            return ajax.pipe(
                switchMap((resp) => {
                    return of(ArtworkMsg('ArtworkGrid.FetchSuccess', resp));
                }),
                catchableUnauthenticated(({ error }) => {
                    return of(ArtworkMsg('ArtworkGrid.FetchError', error));
                }),
            );
        }),
    );
}
